<template>
	<div v-if="products.length > 0">
		<VueSlickCarousel :initialSlide="0" :arrows="true" :dots="isDesktop" :infinite="false" @beforeChange="setIndex">
			<template #prevArrow>
				<button :class="{'d-none' : !hasPrev}" :style="{ '--arrow-color': arrowColor }" class="carousel-control-prev">
					<i class="bi bi-chevron-right"></i>
				</button>
			</template>
			<template #nextArrow>
				<button :class="{'d-none' : !hasNext}" :style="{ '--arrow-color': arrowColor }" class="carousel-control-next">
					<i class="bi bi-chevron-left"></i>
				</button>
			</template>
			<div v-for="(productGroup, index) in productGroups" :key="index">
				<div class="row ml-3 mr-3">
					<div v-for="(product, indexone) in productGroup" :key="indexone" :class="columnClass">
						<product-item :product="product" />
					</div>
				</div>
			</div>
		</VueSlickCarousel>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import ProductItem from './sections/partials/ProductItem.vue';

export default {
	name: 'sliderProduct',
	components: {
		VueSlickCarousel,
		ProductItem,
	},
	data() {
		return {
			currentIndex: 0,
			productsPerRow: 4,
		};
	},
	props: {
		products: {
			type: Array,
			default: () => [],
		},
		customArrowColor: {
			type: String,
			default: '#ffffff',
		},
	},
	computed: {
		productGroups() {
			const groups = [];
			if (window.innerWidth < 768) {
				this.changeProductPerRow(1);
			}
			if (window.innerWidth >= 768) {
				this.changeProductPerRow(2);
			}
			if (window.innerWidth >= 1024) {
				this.changeProductPerRow(3);
			}
			if (window.innerWidth >= 1400) {
				this.changeProductPerRow(6);
			}

			for (let i = 0; i < this.products.length; i += this.productsPerRow) {
				groups.push(this.products.slice(i, i + this.productsPerRow));
			}
			return groups;
		},
		columnClass() {
			let size = 'col-sm-6 col-md-3';

			if (this.productsPerRow === 6) {
				size = 'col-sm-6 col-md-2 d-flex justify-content-center';
			}

			if (this.productsPerRow === 4) {
				size = 'col-sm-6 col-md-3 d-flex justify-content-center';
			}

			if (this.productsPerRow === 3) {
				size = 'col-sm-6 col-md-4 d-flex justify-content-center';
			}

			if (this.productsPerRow === 2) {
				size = 'col-sm-6 col-md-6 d-flex justify-content-center';
			}

			if (window.innerWidth < 768) {
				size = 'col-12 d-flex justify-content-center';
			}

			return size;
		},
		isDesktop() {
			return window.innerWidth >= 768;
		},
		arrowColor() {
			return this.customArrowColor;
		},
		hasPrev() {
			return this.currentIndex !== 0;
		},
		hasNext() {
			return this.currentIndex !== this.productGroups.length - 1;
		},
	},
	methods: {
		setIndex(oldSlideIndex, newSlideIndex) {
			this.currentIndex = newSlideIndex;
		},
		changeProductPerRow(value) {
			this.productsPerRow = value;
		},
	},
};
</script>

<style lang="scss" scoped>
.slick-prev:before,
.slick-next:before
{
	content: '';
}
.slick-next {
	opacity: 1;
	z-index: 1;
	right: 0px;
}
.slick-prev {
	opacity: 1;
	z-index: 2;
	left: -10px;
}

.carousel-control-prev{
	opacity: 1;
	position: absolute;
	width: 36px;
	height: 36px;
	left: -10px;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;

	background: #FFFFFF;
	/* Small Shadow */

	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
	border-radius: 26px;
	transform: matrix(-1, 0, 0, 1, 0, 0);

	/* Inside auto layout */
	flex: none;
	order: 4;
	flex-grow: 0;
	z-index: 4;
	i {
		color: #616672;
	}
}
.carousel-control-next {
	opacity: 1;
	position: absolute;
	width: 36px;
	height: 36px;
	right: -10px;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
	background: #FFFFFF;

	/* Small Shadow */
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
	border-radius: 26px;
	transform: matrix(-1, 0, 0, 1, 0, 0);

	/* Inside auto layout */
	flex: none;
	order: 4;
	flex-grow: 0;
	z-index: 4;
	i {
		color: #616672;
	}
}

@media only screen and (max-width: 768px) {
	.slick-next {
		z-index: 1;
		right: 0px;
	}
	.slick-prev {
		z-index: 5;
		left: 0px;
	}
	.carousel-control-prev{
		left: 0px;
		width: 30px;
		height: 30px;
	}
	.carousel-control-next{
		right: 0px;
		width: 30px;
		height: 30px;
	}
}

.slick-prev,
.slick-next
{
	font-size: 17px;
	color: rgb(255, 255, 255);
}

.bi::before{
    vertical-align: 0px;
}
</style>
